import moment from 'moment';

import * as types from '../constants/actionTypes';
import initialState from '../store/initialState';

import {flattenMessages} from '../util/IntlUtils';

import messages from '../constants/locale/messages';

export default function intlReducer(state = initialState.intl, action) {
    switch (action.type) {
        case types.SET_LOCALE: {
            moment.locale(action.locale);
            return {
                ...state,
                locale: action.locale,
                messages: flattenMessages(messages[action.locale])
            };
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/intlReducer.js